import { grey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  content: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(6, 2, 4),
    background:
      "radial-gradient(circle at top, rgba(41, 121, 255, 0.08), transparent 38%), #fafafa",
  },
  main: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "100%",
    maxWidth: 460,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(5, 4, 4),
    borderRadius: theme.spacing(1.5),
    border: `1px solid ${grey[300]}`,
    boxShadow: "0 20px 60px rgba(15, 23, 42, 0.08)",
    backgroundColor: theme.palette.common.white,
    textAlign: "center",
  },
  title: {
    marginBottom: theme.spacing(1.5),
    fontWeight: 600,
    fontSize: theme.spacing(3.5),
    lineHeight: `${theme.spacing(4)}px`,
  },
  description: {
    marginBottom: theme.spacing(4),
    color: grey[600],
    maxWidth: 360,
  },
  button: {
    minWidth: 200,
    height: 44,
    borderRadius: theme.spacing(1),
    fontWeight: 600,
  },
  loader: {
    marginBottom: theme.spacing(3),
  },
  footer: {
    marginTop: theme.spacing(4),
  },
}));

export default useStyles;
